import Caption from 'LuxKit/Typography/Caption'
import { rem } from 'polished'
import styled from 'styled-components'

const DESCRIPTION_SEPARATOR = '•'

const DescriptionSeparator = styled.span`
  margin: 0 ${rem(8)};
`

interface Props {
  primaryText: string
  secondaryText?: string
}

function MetaSearchV2SearchBarDescription({ primaryText, secondaryText }: Props) {
  return (
    <Caption variant="large" lineClamp={1}>
      {secondaryText ? (
        <>
          {primaryText}
          <DescriptionSeparator>{DESCRIPTION_SEPARATOR}</DescriptionSeparator>
          {secondaryText}
        </>
      ) : primaryText}
    </Caption>
  )
}

export default MetaSearchV2SearchBarDescription
